import styled from '@emotion/styled';
import { Space } from '@lib/uikit/theme/types';
import { MouseEvent } from 'react';

import Icon from '../icons/icon';

interface Props {
    distance: Space;
    move: 'back' | 'forth';
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

const Button = styled.button<Props>`
    z-index: 9999;
    cursor: pointer;
    pointer-events: auto;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    transform: translateY(-50%);
    left: ${({ theme, distance, move }) =>
        move === 'back' ? theme.spacing[distance] : undefined};
    right: ${({ theme, distance, move }) =>
        move === 'forth' ? theme.spacing[distance] : undefined};
    backdrop-filter: ${({ theme }) => theme.blurs.default};
    background: ${({ theme }) => theme.palette.whiteAlpha[700]};
`;

const ContentScrollerBodyNavigationButton = ({
    distance,
    move,
    onClick,
}: Props) => (
    <Button distance={distance} move={move} onClick={onClick}>
        <Icon
            name={`chevron_${move === 'back' ? 'left' : 'right'}`}
            size='medium'
        />
    </Button>
);

export default ContentScrollerBodyNavigationButton;
